/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Byoa_Last_OkInputs */

const en_byoa_last_ok = /** @type {(inputs: Byoa_Last_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last tested: ${i?.when}`)
};

const id_byoa_last_ok = /** @type {(inputs: Byoa_Last_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terakhir diuji: ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Last tested: {when}" |
*
* @param {Byoa_Last_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_last_ok = /** @type {((inputs: Byoa_Last_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Last_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_last_ok(inputs)
	return en_byoa_last_ok(inputs)
});